import { useState } from "react";

import { TenantRole } from "@nens/rana/api-v1";

import { useTenantUserListQuery } from "@/queries/query-tenant-user";

import { useInviteUserToTenant } from "../api/add-tenant-user";

export function useTenantUserInviteModal(onClose: () => void) {
  // User enters an email address. Test that is an email address.
  // If the email address is already part of the tenant, say so.
  // Otherwise, offer to send an invitation to that email address instead.

  // Get all tenant users
  const tenantUsersQuery = useTenantUserListQuery({ offset: 0, limit: 100 });
  const tenantUsers = tenantUsersQuery?.data?.items ?? [];

  // Search field
  const [searchString, setSearchString] = useState<string>("");
  const [role, setRole] = useState<TenantRole>(TenantRole.Member);

  // If the search field is an email address, we can invite the user.
  const isValidEmail = (s: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
  };
  const searchIsEmail = isValidEmail(searchString);
  const emailExists = tenantUsers.some(
    (user) => user.email.toLowerCase() === searchString.toLowerCase()
  );

  // Functions to invite users that don't exist yet.
  const inviteUsersMutation = useInviteUserToTenant();
  const inviteUser = () => {
    if (searchIsEmail && !emailExists) {
      inviteUsersMutation.mutate(
        { email: searchString, role },
        {
          onSuccess: onClose,
        }
      );
    }
  };

  const isLoading = inviteUsersMutation.isMutating;
  const showInviteButton = searchIsEmail && !emailExists && !isLoading;

  return {
    searchString,
    setSearchString,
    role,
    setRole,
    inviteUser,
    showInviteButton,
    errors: inviteUsersMutation.errors,
    emailExists,
    isLoading,
  };
}
